<ng-container *ngIf="isFirst">
    <i class="fas fa-home"></i>
</ng-container>

<ng-container *ngIf="!isFirst">
    {{folder.name}}
</ng-container>
